import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logOut } from '../../store/modules/auth/actions';


const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logOut());
  }, [dispatch]);

  return null;
};

export default Logout;
